const translations = {
    selectDate: 'Select Date'
};

export default translations;
